module.exports = __webpack_public_path__ + "media/day/182-f1fc1c5b.svg";